import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import HandshakeIcon from "@mui/icons-material/Handshake";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";

import HubGrid, { HUB_ICON_SX, HubNoAccess } from "./HubGrid";
import { canSeeAgreements, canSeeApplicants } from "./extensionAccess";

// Puerta de entrada a Extensión. El módulo creció lo suficiente como para no
// caber en un solo mosaico —aspirantes, convenios, entidades y dos
// configuraciones—, así que se parte en dos ramas y cada una tiene su propio
// hub: aquí sólo se elige de cuál de las dos se va a trabajar.
//
// Quien sólo alcanza una rama no ve esta pantalla: se le lleva directo a la
// suya, porque elegir entre una sola opción no es elegir.
export default function ExtensionHub() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.value);

  const options = useMemo(() => {
    const items = [];
    if (canSeeApplicants(user)) {
      items.push({
        key: "applicants",
        label: "Aspirantes",
        description: "Banco de hojas de vida: consulta, convocatorias y validación de documentos.",
        icon: <PeopleAltIcon sx={HUB_ICON_SX} />,
        path: "/extension/aspirantes",
      });
    }
    if (canSeeAgreements(user)) {
      items.push({
        key: "agreements",
        label: "Convenios",
        description: "Convenios y contratos, las entidades con las que se firman y su documentación.",
        icon: <HandshakeIcon sx={HUB_ICON_SX} />,
        path: "/extension/convenios",
      });
    }
    return items;
  }, [user]);

  useEffect(() => {
    if (options.length === 1) navigate(options[0].path, { replace: true });
  }, [options, navigate]);

  if (options.length === 0) {
    return (
      <HubNoAccess
        title="Sin acceso a Extensión"
        message="Tu usuario no tiene permisos para ningún módulo de Extensión."
      />
    );
  }
  // No se pinta nada mientras corre la redirección, para que el mosaico no
  // parpadee antes de desaparecer.
  if (options.length === 1) return null;

  return (
    <HubGrid
      title="Extensión"
      subtitle="Selecciona un módulo"
      options={options}
    />
  );
}
